import clsx from 'clsx';
import { error, published } from '@wordpress/icons';
import Icon from '../icon';
import Spinner from '../spinner';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ValidityIndicator({
  id,
  type,
  message
}) {
  const ICON = {
    valid: published,
    invalid: error
  };
  return /*#__PURE__*/_jsxs("p", {
    id: id,
    className: clsx('components-validated-control__indicator', `is-${type}`),
    children: [type === 'validating' ? /*#__PURE__*/_jsx(Spinner, {
      className: "components-validated-control__indicator-spinner"
    }) : /*#__PURE__*/_jsx(Icon, {
      className: "components-validated-control__indicator-icon",
      icon: ICON[type],
      size: 16,
      fill: "currentColor"
    }), message]
  });
}